/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_After_Duration_OkInputs */

const en_us2_workout_after_duration_ok = /** @type {(inputs: Workout_After_Duration_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Just right`)
};

const pt_br2_workout_after_duration_ok = /** @type {(inputs: Workout_After_Duration_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Foi boa`)
};

const es_419_workout_after_duration_ok = /** @type {(inputs: Workout_After_Duration_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Justa`)
};

const pt_pt2_workout_after_duration_ok = /** @type {(inputs: Workout_After_Duration_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Foi boa`)
};

const fr_fr2_workout_after_duration_ok = /** @type {(inputs: Workout_After_Duration_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parfaite`)
};

const de_de2_workout_after_duration_ok = /** @type {(inputs: Workout_After_Duration_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genau richtig`)
};

const it_it2_workout_after_duration_ok = /** @type {(inputs: Workout_After_Duration_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giusta`)
};

/**
* | output |
* | --- |
* | "Just right" |
*
* @param {Workout_After_Duration_OkInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_after_duration_ok = /** @type {((inputs?: Workout_After_Duration_OkInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_After_Duration_OkInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_after_duration_ok(inputs)
	if (locale === "es-419") return es_419_workout_after_duration_ok(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_after_duration_ok(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_after_duration_ok(inputs)
	if (locale === "de-DE") return de_de2_workout_after_duration_ok(inputs)
	if (locale === "it-IT") return it_it2_workout_after_duration_ok(inputs)
	return en_us2_workout_after_duration_ok(inputs)
});
export { workout_after_duration_ok as "workout-after.duration_ok" }